'use strict'

import _ from 'underscore'
import axios from 'axios'
import qs from 'qs'
import { generateMap } from './Wapi.js'
import API_BASE from '@/components/services/endpoint_calculator'

let API_KEY = 'r7eXjA4o1kf8eJS7LwddJmYz'

const headers = {
  'X-API-KEY': API_KEY,
}

const categoryMap = generateMap()

const bearerHeaders = (token = null) => {
  if (!token) return headers
  return _.extend(headers, {
    Authorization: `Bearer ${token}`,
  })
}
console.log('Using API', API_BASE)

class Api {
  translateTags(tagList) {
    let tagMap = {
      153: 'layout-boxes-row',
      154: 'layout-boxes',
      155: 'intro',
      157: 'icon-boxes',
      158: 'only-professional',
    }

    let translatedList = []

    _.each(tagList, (item) => {
      let name = null
      if (_.has(tagMap, item)) translatedList.push(tagMap[item])
    })

    return translatedList
  }
  getApiUrl() {
    return API_BASE
  }
  redirectToCommunity(token) {
    return axios({
      url: `${API_BASE}/jwt/platformLogin/`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  getPermissions() {
    return axios({
      url: `${API_BASE}/esreps/permissions/`,
      method: 'get',
      headers: {
        'X-API-KEY': API_KEY,
      },
    })
  }
  getTrainerList(params) {
    params['cache'] = 1
    return axios({
      params,
      url: `${API_BASE}/esreps/trainers/`,
      method: 'get',
      headers: {
        'X-API-KEY': API_KEY,
      },
    })
  }
  getTrainerDetail(id) {
    return axios({
      url: `${API_BASE}/esreps/trainers/${id}/`,
      method: 'get',
      headers: {
        'X-API-KEY': API_KEY,
      },
    })
  }
  getVcard(id) {
    return axios({
      url: `${API_BASE}/esreps/vcard/${id}/`,
      method: 'get',
      headers: {
        'X-API-KEY': API_KEY,
      },
    })
  }
  updateVcard(id, params, token) {
    return axios({
      data: qs.stringify(params),
      url: `${API_BASE}/esreps/vcard-update/${id}/`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  contactVcard(id, params) {
    return axios({
      data: qs.stringify(params),
      url: `${API_BASE}/esreps/vcard-contact/${id}/`,
      method: 'post',
      headers: {
        'X-API-KEY': API_KEY,
      },
    })
  }
  welcomeEmail(token) {
    return axios({
      data: qs.stringify({token}),
      url: `${API_BASE}/esreps/emails/welcome/`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  listContacts(token) {
    return axios({
      data: qs.stringify({}),
      url: `${API_BASE}/esreps/contacts/list/`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  banner(identifier, token) {
    return axios({
      data: qs.stringify({identifier}),
      url: `${API_BASE}/esreps/banner/`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  bannerClick(identifier, token) {
    return axios({
      data: qs.stringify({identifier, token}),
      url: `${API_BASE}/esreps/banner-click/`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  newContact(professional, name, phone, email, message) {
    return axios({
      data: qs.stringify({ professional, name, phone, email, message }),
      url: `${API_BASE}/esreps/contacts/add/`,
      method: 'post',
    })
  }
  getFormConfiguration() {
    return axios.get(`${API_BASE}/esreps/forms/`)
  }
  getTitleList() {
    return axios.get(`${API_BASE}/esreps/level_course_titles/`)
  }
  getCategories(parent) {
    return axios.get(
      `${API_BASE}/core/content/categories/?root=${categoryMap[parent]}`
    )
  }
  getCourses(category) {
    return axios.get(
      `${API_BASE}/esreps/level-course-list/?category=${category}`
    )
  }
  getSubcategories(category) {
    return axios.get(
      `${API_BASE}/esreps/cec-subcategory-list/?category=${category}`
    )
  }
  getCategoriesByParent(parent) {
    return axios.get(`${API_BASE}/core/content/categories/?root=${parent}`)
  }
  getCategoryBySlug(slug) {
    return axios.get(`${API_BASE}/core/content/category/?slug=${slug}`)
  }
  getEntries(category, token = null) {
    return axios({
      url: `${API_BASE}/core/content/posts/?category=${categoryMap[category]}`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  proxy(href) {
    return axios.get(href)
  }
  getEntriesByParent(category, token = null) {
    return axios({
      url: `${API_BASE}/core/content/posts/?category=${category}`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  getEntry(slug, token = null) {
    return axios({
      url: `${API_BASE}/core/content/post/?slug=${slug}`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  cecCategories() {
    return axios.get(`${API_BASE}/esreps/cec-categories/`)
  }
  cecCourses() {
    return axios.get(`${API_BASE}/esreps/cec-courses/`)
  }
  lopd(token) {
    return axios({
      url: `${API_BASE}/esreps/lopd/?token=${token}`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  updateCecLink(data, seed, token) {
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/esreps/cec-link-update/?seed=${seed}&token=${token}`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  registerUser(data) {
    data.frontend = '1'
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/esreps/register-user/`,
      method: 'post',
    })
  }
  getPaymentLink(uuid) {
    return axios.get(
      `${API_BASE}/esreps/register-user-payment-link/?uuid=${uuid}`
    )
  }
  getPaymentConfirmation(uuid) {
    return axios.get(
      `${API_BASE}/esreps/register-payment-confirmation/?uuid=${uuid}`
    )
  }
  updateCec(data, seed, token) {
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/esreps/cec-update/?seed=${seed}&token=${token}`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  migration(token) {
    return axios({
      url: `${API_BASE}/esreps/migration-forms/`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  specs() {
    return axios({
      url: `${API_BASE}/esreps/specs/`,
      method: 'get',
    })
  }
  me(token) {
    return axios({
      url: `${API_BASE}/esreps/me/`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  migrationPackage(token, pack) {
    return axios({
      url: `${API_BASE}/esreps/school-migration-detail/?package=${pack}`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  preMigrationPackage(token, pack) {
    return axios({
      url: `${API_BASE}/esreps/school-pre-migration-status/?package=${pack}`,
      method: 'get',
      headers: bearerHeaders(token),
    })
  }
  updatePassword(data, token) {
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/esreps/update-password/`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  userPartialUpdate(data, token) {
    if (!token) {
      throw new Error('Token inválido')
    }
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/esreps/partial-update-user/?token=${token}`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  updateUser(data, token) {
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/esreps/update-user/`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  recoverPassword(email) {
    return axios({
      data: qs.stringify({ email }),
      url: `${API_BASE}/esreps/send-recovery/`,
      method: 'post',
      headers,
    })
  }
  changePassword(remember_token, password, token) {
    return axios({
      data: qs.stringify({ remember_token, password }),
      url: `${API_BASE}/esreps/change-password/`,
      method: 'post',
      headers,
    })
  }
  auth(username, password) {
    return axios({
      data: qs.stringify({ username, password }),
      url: `${API_BASE}/esreps/auth/`,
      method: 'post',
      headers,
    })
  }
  professionals(token, data, page) {
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/esreps/professionals/?page=${page}`,
      method: 'post',
      headers: bearerHeaders(token),
    })
  }
  registerAccount(username, password) {
    return axios({
      data: qs.stringify({ username, password }),
      url: `${API_BASE}/empleo/register-demandante-step1/`,
      method: 'post',
    })
  }
  updateAccount(data) {
    return axios({
      data: qs.stringify(data),
      url: `${API_BASE}/empleo/account/update/`,
      method: 'post',
    })
  }
  options() {
    return axios({
      data: qs.stringify(),
      url: `${API_BASE}/empleo/options/`,
      method: 'post',
    })
  }
  facilities(filters = {}) {
    let suffix =
      filters && _.has(filters, 'page') ? `?page=${filters.page}` : ''
    return axios({
      url: `${API_BASE}/esreps/facilities/${suffix}`,
      method: 'get',
      headers,
    })
  }
  facility(slug = null) {
    let suffix = slug ? `?slug=${slug}` : ''
    return axios({
      url: `${API_BASE}/esreps/facilities/${suffix}`,
      method: 'get',
      headers,
    })
  }
}

export default new Api()



// WEBPACK FOOTER //
// ./src/components/services/Api.js